import React, {useState} from 'react';
import {Box, Button, Card, CardContent, InputLabel, Select, Typography} from '@mui/material';
import {Trans, useTranslation} from 'react-i18next';
import Grid from "@mui/material/Grid2";
import Stepper from "@mui/material/Stepper";
import Step from "@mui/material/Step";
import StepLabel from "@mui/material/StepLabel";
import {getItemPrice} from "../../managers/cartManager/cartManager";
import ListItemText from "@mui/material/ListItemText";
import {grey} from "@mui/material/colors";
import CartItemParams from "../../checkout/components/CartItemParams";
import OrderDesigns from "../../user/userPage/components/OrderDesigns";
import StatusIcon from "../../user/userPage/components/StatusIcon";
import FunctionHandler from "../../utils/functionHandler";
import DataForm from "../../checkout/components/billingData/DataForm";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import {useNavigate} from "react-router";
import LockerCard from "../../checkout/components/shipping/LockerCard";
import CardActionArea from "@mui/material/CardActionArea";
import {LocalShipping, Person} from "@mui/icons-material";
import {StyledMuiCard} from "../../checkout/components/billingData/UserInfo";

const statuses = ['open', 'payment-accepted', 'in-production', 'shipping', 'finalized'];

export function getStatusNumber(status) {
    return (typeof status === 'string') ? statuses.indexOf(status) : status;
}

function AdminOrderCard({order, submitStatus}) {
    const navigate = useNavigate();
    const {t} = useTranslation()
    const {items, shipping, nr, status, discount, invoiceData, email} = order;
    const nrStatus = getStatusNumber(status);
    const [showDesigns, setShowDesigns] = useState(false);
    const [newStatus, setNewStatus] = useState(nrStatus);
    const [openedView, setOpenedView] = useState('shipping');

    const handleViewChange = (id) => {
        setOpenedView(id);
    }

    const getTotalPrice = () => {
        let total = 0;
        Object.keys(items).forEach(itemKey => {
            const item = items[itemKey];
            total += (item.product.price * item.nr * (1 - item.discount))
        });

        total = total * (1 - (discount || 0));
        total += shipping.price;
        return total;
    }

    const getImages = (item, product) => {
        let images = product.images;
        return <OrderDesigns images={images}/>;
    }

    const getDesignsList = (item, product) => {
        let images = product.designs;

        if (product.necessaryDesigns && Number(product.necessaryDesigns)) {
            images = order.selectedDesigns?.filter(design => design.value?.size === item.params?.size?.label).map(design => ({
                src: FunctionHandler.getFunctionUrl(`/dep/${design.value.src}`),
                nr: design.value.nr
            }));
        }

        if (item.params?.file?.path) {
            images = [{
                src: FunctionHandler.getFunctionUrl(`/dep/${item.params?.file?.path}`),
                nr: 1
            }];
        }

        return <OrderDesigns images={images} clickable/>;
    }

    const totalPrice = order?.totalPrice || getTotalPrice();

    console.log(order);
    const handleStatusChange = (event) => {
        setNewStatus(event.target.value);
    }

    const submitNewStatus = () => {
        submitStatus(newStatus);
    }

    return (<>
            <Button sx={{mt: 2}} color={'secondary'} onClick={() => navigate(-1)}>
                &lt; <Trans i18nKey={'buttons.back'}/>
            </Button>
            <Card sx={{maxWidth: 500}}>
                <CardContent sx={{pt: 2}}>
                    <Stepper alternativeLabel activeStep={nrStatus} sx={{padding: 0}}>
                        {statuses.map((label) => (
                            <Step key={label}>
                                <StepLabel slots={{stepIcon: StatusIcon}} slotProps={{labelName: label}}/>
                            </Step>
                        ))}
                    </Stepper>
                </CardContent>
                <CardContent>
                    <FormControl size={'small'} fullWidth>
                        <InputLabel id="status-select-label">Change Status</InputLabel>
                        <Select
                            labelId="status-select-label"
                            id="status-select"
                            value={newStatus}
                            label="Change Status"
                            onChange={handleStatusChange}
                        >
                            {statuses.map((item, index) => <MenuItem value={index}>{item}</MenuItem>)}
                        </Select>
                    </FormControl>
                    <Box sx={{display: 'flex', justifyContent: 'flex-end', pt: 2}}>
                        <Button variant={'contained'} onClick={submitNewStatus}>Submit</Button>
                    </Box>
                </CardContent>
                <CardContent>
                    <Typography variant="h5" component="div">
                        <Trans i18nKey="orderCard.title">Order Details</Trans>
                    </Typography>
                    <Grid container spacing={2}>
                        <Grid size={12}>
                            <Typography variant="body1">
                                <Trans i18nKey="orderCard.orderNr">Order Number:</Trans>
                            </Typography>
                            <Typography variant="body2" color="text.secondary">
                                {nr}
                            </Typography>
                        </Grid>
                        <Typography>User email: {email}</Typography>

                        <FormControl component="fieldset" fullWidth>
                            <Box
                                sx={{
                                    display: 'flex',
                                    flexDirection: {xs: 'column', sm: 'row'},
                                    gap: 2,
                                }}
                            >
                                <StyledMuiCard selected={openedView === 'shipping'}>
                                    <CardActionArea
                                        onClick={() => handleViewChange('shipping')}
                                        sx={{
                                            '.MuiCardActionArea-focusHighlight': {
                                                backgroundColor: 'transparent',
                                            },
                                            '&:focus-visible': {
                                                backgroundColor: 'action.hover',
                                            },
                                        }}
                                    >
                                        <CardContent sx={{display: 'flex', alignItems: 'center', gap: 1}}>
                                            <LocalShipping
                                                fontSize="small"
                                                sx={[
                                                    (theme) => ({
                                                        color: 'grey.400',
                                                        ...theme.applyStyles('dark', {
                                                            color: 'grey.600',
                                                        }),
                                                    }),
                                                    openedView === 'shipping' && {
                                                        color: 'primary.main',
                                                    },
                                                ]}
                                            />
                                            <Typography sx={{fontWeight: 'medium'}}><Trans
                                                i18nKey={'orderCard.shippingAddress'}/></Typography>
                                        </CardContent>
                                    </CardActionArea>
                                </StyledMuiCard>
                                <StyledMuiCard selected={openedView === 'userInfo'}>
                                    <CardActionArea
                                        onClick={() => handleViewChange('userInfo')}
                                        sx={{
                                            '.MuiCardActionArea-focusHighlight': {
                                                backgroundColor: 'transparent',
                                            },
                                            '&:focus-visible': {
                                                backgroundColor: 'action.hover',
                                            },
                                        }}
                                    >
                                        <CardContent sx={{display: 'flex', alignItems: 'center', gap: 1}}>
                                            <Person
                                                fontSize="small"
                                                sx={[
                                                    (theme) => ({
                                                        color: 'grey.400',
                                                        ...theme.applyStyles('dark', {
                                                            color: 'grey.600',
                                                        }),
                                                    }),
                                                    openedView === 'userInfo' && {
                                                        color: 'primary.main',
                                                    },
                                                ]}
                                            />
                                            <Typography sx={{fontWeight: 'medium'}}><Trans
                                                i18nKey={`orderCard.invoice`}/></Typography>
                                        </CardContent>
                                    </CardActionArea>
                                </StyledMuiCard>
                            </Box>
                        </FormControl>
                        {openedView === 'shipping' ?
                            <Grid size={12}>
                                {shipping.type === 'normal' &&
                                    <DataForm userInfo={shipping.address} validity={{}} onChange={() => {
                                    }} onBlur={() => {
                                    }} readOnly/>}
                                {shipping.type === 'easyBox' &&
                                <LockerCard locker={shipping.easyBox} admin/>}
                                {shipping.type === 'personal' && <Typography>
                                    <Trans i18nKey={'shippingForm.personal'}/>
                                </Typography>}
                            </Grid> :
                            <Grid size={12}>
                                <DataForm
                                    userInfo={invoiceData?.userInfo || {}}
                                    validity={{}}
                                    onChange={() => {
                                    }}
                                    onBlur={() => {
                                    }}
                                    readOnly
                                    personType={invoiceData?.type}/>
                            </Grid>
                        }

                        <Grid size={12}>
                            <Typography variant="body1">
                                <Trans i18nKey="orderCard.payment">Payment Type:</Trans>
                            </Typography>
                            <Typography variant="body2" color="text.secondary">
                                {t(`paymentForm.${order.paymentType}`)}
                            </Typography>
                        </Grid>

                        <Grid size={12}>
                            <Typography variant="body1">
                                <Trans i18nKey="orderCard.totalPrice">Total Price:</Trans>
                            </Typography>
                            {order?.discount ? <ListItemText
                                    sx={{maxHeight: '80px'}}
                                    primary={<Typography variant="body2" color="text.secondary">
                                        {totalPrice.toFixed(2)} Lei
                                    </Typography>}
                                    secondary={<Typography variant="body2" sx={{
                                        textDecoration: 'line-through',
                                        color: grey[400]
                                    }}>
                                        {(totalPrice - order?.totalDiscountAmount).toFixed(2)} Lei
                                    </Typography>}
                                /> :
                                <Typography variant="body2" color="text.secondary">
                                    {totalPrice.toFixed(2)} Lei
                                </Typography>}
                        </Grid>
                    </Grid>
                </CardContent>

                <CardContent>
                    <Typography variant="h6">
                        <Trans i18nKey={'header.Products'}/>:
                    </Typography>
                </CardContent>
                {Object.keys(items).map(key => {
                    const item = items[key];
                    const {product} = item;
                    return <CardContent key={key} sx={{pt: 0}}>
                        <Grid container>
                            <Grid flexGrow={1}>
                                <Typography variant="body1">
                                    <Trans i18nKey={product.name}/> (x{item.nr})
                                </Typography>
                                <Typography variant="caption">
                                    ({getItemPrice(item)} Lei)
                                </Typography>
                            </Grid>
                            <Grid>
                                <Typography variant="body1">
                                    {((item.nr * getItemPrice(item)) * (1 - item.discount)).toFixed(2)} Lei
                                </Typography>
                            </Grid>
                        </Grid>
                        {product.params ? <Box sx={{pt: 1}}>
                            <CartItemParams params={product.params} values={item.params} itemKey={key}
                                            productId={product.id} disableEdit/>
                        </Box> : ''}
                        {getImages(item, product)}
                        {showDesigns ? <>
                            <Typography sx={{pt: 3}}>Designs: </Typography>
                            {getDesignsList(item, product)}
                        </> : <Button sx={{pt: 3}} onClick={() => setShowDesigns(true)}>show designs</Button>}
                    </CardContent>
                })}
            </Card>
        </>
    );
}

export default AdminOrderCard;

export {statuses};